import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, Container, Modal, ModalBody, ModalHeader } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Row, Col, Button } from "reactstrap";
import { MaterialReactTable } from "material-react-table";
import { handleExportData } from "../../Utils/ExportToCsv";
import { useNavigate } from "react-router-dom";
import { MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAllResources } from "../../../slices/resources/thunk";
import { ResourcecolumnData } from "./constants/ColumnForResource";
import { deleteresource } from "../../../slices/resources/deleteresource/thunk";
import { ToastContainer, toast } from "react-toastify";
import { Loader } from "../../Utils/Loader";
import { setEditSuccessMessage, setSuccessMessage } from "../../../slices/toastMessage/action";
import CommonModal from "../../Utils/CommonModal";
import { PAGE_TITLES } from "../../Common/constants";
import { getView } from '../../../slices/View/thunk';
import { useColumnSettings } from "../../Utils/useColumnSettings";
import { bulkDelete } from "../../../slices/BulkDelete/thunk";
import { QuotaForm } from "../../Charging/QuotaForm";
import AddResources from "./AddResources";
import { hasPermission } from "../../Utils/UtilityFunctions";

function ResourcesListings() {
  const [resources, setResources] = useState([]);
  const [messageForPopUp, setMessageForPopUp] = useState('')
  const allResourceData = [];
  const isCurrency = [];
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();
  const [resourceName, setResourceName] = useState("");
  const [modalForBulkDelete, setModalForBulkDelete] = useState(false)
  const [selectedRowsForBulkDelete, setSelectedRowsForBulkDelete] = useState()
  const [resourceArray, setResourceArray] = useState([]);
  const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage)
  const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage);
  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap
  );

  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );
  const resourcePermission = hasPermission(permissionsMap, "pricing", "resource")
  const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")
  const view = useSelector((state) => state.View.getView);
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [selectAllResource, setSelectAllResource] = useState(false)
  const [selectedResource, setSelectedResource] = useState([])
  const [globalFilter, setGlobalFilter] = useState('');
  const [columnFilters, setColumnFilters] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const checkboxRef = useRef(null);
  const isMobile = window.innerWidth <= 768;
  const [modalOpen, setModalOpen] = useState(false)
  const [tooltipOpen, setTooltipOpen] = useState({});
  const toggleModals = () => {
    setModalOpen(prev => !prev);
  };
  const toggleModal = (id, singleOrMulti) => {
    if (singleOrMulti === "single") {
      setResourceName(id);
      setModal(!modal);
    } else {
      setSelectedRowsForBulkDelete(id)
      setModalForBulkDelete(!modalForBulkDelete)
    }
    document.body.style.overflow = 'auto'
  };

  useEffect(() => {
    dispatch(getAllResources(setLoading));
    dispatch(getView(setLoading));
  }, [dispatch]);

  const resourceData = useSelector((state) => state.Resources.resources);

  useEffect(() => {
    resourceData.forEach((anotherElement) => {
      allResourceData.push(anotherElement);
    });
    setResources(allResourceData);
  }, [resourceData]);

  const navigateToAddResources = () => {
    let path = "/create-resources";
    navigate(path);
  };

  const handleDeleteResource = async (id) => {
    dispatch(deleteresource(id, setLoading, navigate));
    const updatedResources = resources.filter(
      (resource) => resource.name !== id.original.name
    );
    setResources(updatedResources);
  };

  resources.forEach((resource, index) => {
    if (resource && resource.isCurrency === true) {
      isCurrency[index] = "Monetary";
    } else {
      isCurrency[index] = "Non-Monetary";
    }
  });

  useEffect(() => {
    if (showSuccessMessage) {
      toast.success("Resource Created Successfully");
      dispatch(setSuccessMessage(false))
    }
    if (showEditSuccessMessage) {
      toast.success("Resource Updated Successfully");
      dispatch(setEditSuccessMessage(false));
    }
  }, [showSuccessMessage, showEditSuccessMessage, dispatch])

  useEffect(() => {
    let filtered = resources;

    if (globalFilter && globalFilter.trim()) {
      const globalFilterLower = globalFilter.toLowerCase().trim();
      filtered = filtered.filter(row => {
        const searchableFields = [
          row.name,
          row.resourceId,
          row.ceiling,
          row.floor,
          row.consumptionRule,
          row.resourceType,
          row.formattedDates,
          row.createdBy,
          row.isCurrency === true ? "Monetary" : "Non-Monetary"
        ];

        return searchableFields.some(field => {
          if (field == null) return false;

          if (Array.isArray(field)) {
            return field.some(item =>
              item != null && item.toString().toLowerCase().includes(globalFilterLower)
            );
          }
          return field.toString().toLowerCase().includes(globalFilterLower);
        });
      });
    }
    if (columnFilters.length > 0) {
      columnFilters.forEach(filter => {
        if (filter.value && filter.value.trim()) {
          const filterValue = filter.value.toLowerCase().trim();
          filtered = filtered.filter(row => {
            let cellValue = row[filter.id];
            if (filter.id === 'resourceType') {
              const index = resources.findIndex(r => r === row);
              cellValue = isCurrency[index];
            }
            if (cellValue == null) return false;

            if (Array.isArray(cellValue)) {
              return cellValue.some(item =>
                item != null && item.toString().toLowerCase().includes(filterValue)
              );
            }
            return cellValue.toString().toLowerCase().includes(filterValue);
          });
        }
      });
    }
    setFilteredData(filtered);
  }, [globalFilter, columnFilters, resources, isCurrency]);

  const handleCancel = () => {
    setGlobalFilter('');
    setColumnFilters([]);
  };
  const handleGlobalFilterChange = (filter) => {
    setGlobalFilter(filter || '');
  };
  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = selectedResource.length > 0 && selectedResource.length < resources.length;
    }
    setSelectAllResource(selectedResource?.length > 0 && resources?.length > 0 && selectedResource?.length === resources?.length);
  }, [selectedResource, resources.length, setSelectAllResource]);

  let columns = ResourcecolumnData(isCurrency, selectAllResource, setSelectAllResource, resources, setSelectedResource, selectedResource, checkboxRef, isMobile, modalOpen, tooltipOpen, setTooltipOpen);

  const {
    settingsModalOpen,
    viewColumns,
    toggleSettingsModal,
    SettingsSidebar,
    CustomViewModal

  } = useColumnSettings('resource', columns);

  useEffect(() => {
    setModalOpen(settingsModalOpen)
  }, [settingsModalOpen])

  return (
    <React.Fragment>
      <div id="csms" className="page-content bg-white">
        <Container fluid>
          <BreadCrumb title={PAGE_TITLES.RESOURCE_LIST} pageTitle={PAGE_TITLES.PRICING} />
          <ToastContainer position="top-center" />
          <Row>
            <Col >
              <div className="listingjs-table" id="customerList">
                <CardBody>
                  <Row className="  mb-2  table-responsive">
                    {loading && (<Loader />)}
                    {resources ? (
                      <MaterialReactTable
                        columns={columns.filter((column) => viewColumns?.includes(column.accessorKey || column.header))}
                        data={filteredData}
                        enableDensityToggle={false}
                        enableColumnActions={true}
                        manualFiltering
                        onColumnFiltersChange={setColumnFilters}
                        onGlobalFilterChange={handleGlobalFilterChange}
                        state={{
                          globalFilter,
                          columnFilters
                        }}
                        enableRowActions
                        defaultColumn={{
                          // minSize: 1,
                          maxSize: 9001,
                          size: 260,
                          muiTableBodyCellProps: {
                            sx: {
                              fontFamily: "Inter,sans-serif"
                            }
                          },
                          muiTableHeadCellProps: {
                            sx: {
                              fontFamily: "Inter,sans-serif"
                            }
                          }
                        }}
                        muiTableContainerProps={{
                          sx: {
                            border: '1px solid #e9ebec',
                          }
                        }}
                        icons={{
                          DragHandleIcon: () => <i className="ri-drag-move-fill" />,
                        }}
                        displayColumnDefOptions={{
                          'mrt-row-actions': {
                            header: '',
                            enableHiding: true,
                            size: isMobile ? 59 : 50,
                            grow: true
                          },
                        }}
                        initialState={{
                          columnOrder: [
                            'checkbox',
                            'mrt-row-actions',
                            'Resource Name',
                            'Resource Type',
                            'Code',
                            'Ceiling',
                            'Floor',
                            'Consumption Rule'
                          ]
                        }}
                        layoutMode='grid'
                        positionToolbarAlertBanner='none'
                        muiSelectCheckboxProps={{
                          color: 'warning'
                        }}
                        muiSelectAllCheckboxProps={{
                          color: 'warning'
                        }}
                        renderTopToolbarCustomActions={({ table }) => (
                          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                            <h5 className="rv-page-title p-1">Resources List</h5>
                            <div className="d-flex align-items-center">
                              <div className="d-flex ">
                                {resourcePermission && resourcePermission?.has("export") &&
                                  <Button
                                    color="secondary"
                                    className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                    onClick={() => { handleExportData(resources) }}
                                  >
                                    <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                    <span className="px-2 ps-3 ms-2 me-1">Export</span>
                                  </Button>}
                                {resourcePermission && resourcePermission?.has('create') &&
                                  <Button
                                    color="secondary"
                                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 me-2 w-100 w-md-auto text-nowrap"
                                    onClick={() => {
                                      navigateToAddResources()
                                      // setIsEditMode(false);
                                    }}
                                  >
                                    <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                                    <span className="ps-2 ms-2 me-1"> Add Resource</span>
                                  </Button>
                                }

                                {selectedResource?.length && resourcePermission && resourcePermission?.has("bulkdelete") ?
                                  <Button color='main-color' className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100  w-md-auto text-nowrap"
                                    onClick={() => {
                                      const names = selectedResource.map(row => row.name);
                                      let uniqueResources = Array.from(new Set(names))
                                      setResourceArray(uniqueResources);
                                      setMessageForPopUp(`Are you sure you want to delete the selected items?`)
                                      toggleModal(selectedResource, "multi")
                                    }}>
                                    {/* <i className="ri  me-2" /> */}
                                    <i className="ri-delete-bin-5-line label-icon align-middle fs-16 me-1"></i>
                                    <span className="ps-2 ms-2 me-1"> Delete</span>
                                  </Button> : null
                                }
                              </div>
                              {viewPermission && viewPermission?.has("view") &&
                                <div color="secondary" className="btn-icon cursor-img" onClick={toggleSettingsModal}>
                                  <i className="ri-settings-2-line fs-4"></i>
                                </div>}
                            </div>
                          </div>
                        )}
                        renderRowActionMenuItems={({ closeMenu, row }) => [
                          resourcePermission && resourcePermission?.has("update") ?
                            <MenuItem key={`${row.index}.2`} onClick={() => { navigate(`/edit-resource/${row.original.name}`); }}><i className="bx bxs-edit me-2" /> Edit </MenuItem> : null,
                          resourcePermission && resourcePermission?.has("delete") ?
                            <MenuItem className='row-options'
                              key="view"
                              onClick={() => {
                                setMessageForPopUp(`Are you sure you want to Delete this resource "${row.original.name}"?`)
                                toggleModal(row, "single");
                                closeMenu();
                              }}
                            >
                              <i className="ri ri-delete-bin-5-line me-2" />{" "}
                              Delete
                            </MenuItem> : null,
                        ]}
                      />
                    ) : null}
                  </Row>
                </CardBody>

              </div>
            </Col>
            {/* {SettingsSidebar()} */}
            {CustomViewModal()}
          </Row>
        </Container>

      </div>
      <div>
        <CommonModal modalHeader={'Delete Resource'} messageForPopUp={messageForPopUp} toggle={() => { if (modal) { toggleModal(resourceName, "single") } else { toggleModal(selectedRowsForBulkDelete, "multi") } }} open={modalForBulkDelete ? modalForBulkDelete : modal} buttonText={"Yes, Delete It"} modalAction={() => {
          if (modal) {
            handleDeleteResource(resourceName)
            toggleModal(resourceName, "single");
          } else {
            let jsonObj = { ids: resourceArray, type: "Resource" }
            dispatch(bulkDelete(jsonObj, setLoading))
            setSelectAllResource(false)
            setSelectedResource([])
            toggleModal(selectedRowsForBulkDelete, "multi")
          }
        }} />
      </div>
    </React.Fragment>
  );
}

export default ResourcesListings;